import {
  CampaignTypesKey,
  GlobalListPageKey,
  GlobalPageHeaderKey,
  TableTypesKey,
  TextEditorKey,
  UtilsTypesKey
} from 'utils/globalTranslation/TModules';

export const translations = {
  [GlobalListPageKey]: {
    RequestHasBeenApproved: 'La richiesta è stata approvata',
    RequestHasBeenDeleted: 'La richiesta è stata eliminata',
    RequestHasBeenDenied: 'La richiesta è stata rifiutata',
    RequestHasBeenCancelled: 'La richiesta è stata annullata',
    RequestsHaveBeenApproved: 'Le richieste sono state approvate',
    ThisFieldIsRequired: 'Questo campo è obbligatorio',
    SomethingWentWrong: 'Qualcosa è andato storto',
    Edit: 'Modifica',
    Maker: 'Creatore',
    Checker: 'Verificatore',
    Cancel: 'Annulla',
    Confirm: 'Conferma',
    NoData: 'Nessun Dato',
    Day: 'giorno',
    Week: 'settimana',
    Month: 'mese',
    Year: 'anno',
    Days: 'giorni',
    Weeks: 'settimane',
    Months: 'mesi',
    Required: 'Obbligatorio',
    MinValue: 'Deve essere un valore positivo e almeno {{min}}',
    MaxValue: 'Non deve essere maggiore di {{max}}',
    MustBeInteger: 'Deve essere un valore intero',
    MustBeNumber: 'Deve essere un numero',
    InvalidEmail: 'Indirizzo e-mail non valido',
    InvalidUrl: 'URL non valido',
    NotGreaterThanUserLimit: 'Il valore non deve superare il limite utente',
    NotGreaterThanRewardLimit: 'Il valore non deve superare il limite della ricompensa',
    ValueMustBePositive: 'Il valore deve essere positivo',
    ValueMustBeMoreThanZero: 'Il valore deve essere maggiore di zero',
    InvalidCsvXlsx: 'Sono accettati solo file .xlsx/.csv; il tipo di file caricato non è valido.',
    OnlyImageTypes: 'Puoi caricare solo file JPG/JPEG/PNG/SVG!',
    SvgUnprocessable: 'Il file SVG non è elaborabile!'
  },
  [GlobalPageHeaderKey]: {
    RewardRequest: 'Richiesta di ricompensa'
  },
  [CampaignTypesKey]: {
    AllCampaigns: 'Tutte Le Campagne',
    InstantReward: 'Ricompensa immediata',
    Stamp: 'Timbro',
    Game: 'Gioco',
    Quiz: 'Quiz',
    Survey: 'Sondaggio',
    Quest: 'Missione',
    Progress: 'Progresso',
    Raffle: 'Lotteria',
    Streak: 'Serie',
    AllGames: 'Tutti I Giochi',
    SpinTheWheel: 'Gira La Ruota',
    ShakeTheTree: 'Scuoti L’Albero',
    HitThePinata: 'Colpisci La Pignatta',
    ScratchCard: 'Gratta E Vinci',
    Plinko: 'Plinko',
    BubblePop: 'Scoppia Le Bolle',
    ClawMachine: 'Macchina ad artiglio',
    Reward: 'Ricompensa',
    Referral: 'Referenza',
    TeamProgress: 'Progresso Del Team',
    MultipleRuleCampaign: 'Campagna A Regole Multiple',
    Generic: 'Generico',
    RuleTriggerDays: 'Giorni di attivazione della regola',
    TriggerDays: 'Giorni di attivazione',
    TriggerOnSpecificDays: 'Attiva in giorni specifici',
    HoverMe: 'Passa il mouse su di me',
    From: 'Da',
    To: 'A',
    SelectDays: 'Seleziona i giorni',
    SelectTime: "Seleziona l'orario",
    Campaign: 'Campagna',
    Points: 'Punti',
    Cashback: 'Rimborso',
    Voucher: 'Buono',
    Batch: 'Lotto',
    PrizeSet: 'Set premio',
    LoyaltyCurrency: 'Valuta fedeltà',
    Rewards: 'Ricompense',
    Audience: 'Pubblico',
    UpdateCustomerDetails: 'Aggiorna i dettagli del cliente',
    PushEventOnly: 'Invia solo evento'
  },
  [UtilsTypesKey]: {
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica',
    January: 'Gennaio',
    February: 'Febbraio',
    March: 'Marzo',
    April: 'Aprile',
    May: 'Maggio',
    June: 'Giugno',
    July: 'Luglio',
    August: 'Agosto',
    September: 'Settembre',
    October: 'Ottobre',
    November: 'Novembre',
    December: 'Dicembre'
  },
  [TableTypesKey]: {
    PerPage: '/ pagina',
    GoTo: 'Vai a',
    Page: 'Pagina',
    PreviousPage: 'Pagina precedente',
    NextPage: 'Pagina successiva',
    NoData: 'Nessun dato'
  },
  [TextEditorKey]: {
    ButtonTooltip: 'Pulsante',
    ButtonDialogTitle: 'Inserisci pulsante',
    Url: 'URL',
    Text: 'Testo',
    BackgroundColor: 'Colore di sfondo',
    TextColor: 'Colore del testo',
    PaddingVertical: 'Spaziatura verticale',
    PaddingHorizontal: 'Spaziatura orizzontale',
    CornerStyle: 'Stile degli angoli',
    CornerSquare: 'Quadrato',
    CornerRounded: 'Arrotondato',
    CornerPill: 'Pillola',
    BorderRadius: 'Raggio degli angoli',
    Insert: 'Inserisci',
    Unlink: 'Rimuovi collegamento',
    Remove: 'Rimuovi'
  }
};
